import {EmailImage} from './emailImage';
import {TextMessage} from './TextMessage';
import {JsonObject, JsonProperty} from 'json2typescript';
import {EmailImageArrayConverter} from '../../customJsonConverters/EmailImageArrayConverter';
import {TextMessageConverter} from '../../customJsonConverters/TextMessageConverter';
// TODO: Obsolete
@JsonObject('EmailMessage')
export class EmailMessage  {

    @JsonProperty('blockImages',EmailImageArrayConverter)
    blockImages:Array<EmailImage> = [];

    @JsonProperty('blockTextMessages',TextMessageConverter)
    blockTextMessages:Array<TextMessage> = [];

    constructor() {
      // this.blockTextMessages =  [];
      // this.blockImages =  [];
    }


}
